module.exports = __webpack_public_path__ + "static/img/iosBtn.fdfeab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/download/iosBtn.png
// module id = +wks
// module chunks = 3